import { toUsDate } from "../../utils/utils";

export const TaskCard = ({ task, onClick, draggable = false }) => {
  const priorityColor = task?.priority === 'HIGH' ? 'bg-danger/30 text-danger' : task?.priority === 'LOW' ? 'bg-grey/20 text-grey' : 'bg-secondary/10 text-secondary-dark';
  const interactive = !draggable && !!onClick;
  return (
    <div
      className={`border gap-y-5 flex flex-col rounded-xl bg-white p-4 hover:shadow-sm transition select-none ${interactive ? 'cursor-pointer' : ''}`}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={interactive ? onClick : undefined}
      onKeyDown={interactive ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      <div className="flex flex-col">
        <p className="font-sans text-sm font-semibold whitespace-normal break-words [overflow-wrap:anywhere]">{task?.title}</p>
        {task?.description ? (
          <p className="font-sans text-[12px] text-grey mt-1 line-clamp-2">{task?.description}</p>
        ) : null}
      </div>

      <div className="mt-2 flex items-center justify-between">
        <div className="flex items-center gap-1 flex-wrap">
          {(task?.tags || []).map((t, i) => (
            <span key={i} className="text-[10px] font-sans bg-lightgrey px-2 py-0.5 rounded-full">{t}</span>
          ))}
        </div>
        <div className="flex justify-end items-center gap-x-2">

          {task?.due_date ? (
            <span className="text-[11px] text-darkgrey whitespace-nowrap">
              {toUsDate(task.due_date) || String(task.due_date)}
            </span>
          ) : null}
          <span className={`text-[10px] font-sans px-2 py-0.5 rounded-full ${priorityColor}`}>{task?.priority}</span>
        </div>

      </div>
    </div>
  );
};

export default TaskCard;
